export enum RelationshipType {
    Unknown = "unknown",
    User = "users",
    Location = "locations",
    Account = "accounts",
    Rating = "rating",
    Invoice = "invoices",
    Email = "email",
    Promotion = "promotion",
    Banner = "banner",
    Subscription = "subscription",
    Payment = "payment",
    Repair = "repair",
    Newsletter = "newsletter",
    Route = "route",
    Receipt = "receipt",
    ApiKey = "apikey",
    Advert = "advert"
}